window.IlmasPdp = window.IlmasPdp || {};
(function (api) {
  api.JUNK_RE = /solicite\s+presupuesto|el\s+precio\s+no\s+incluye|env[ií]os?\s+gratis|aprovecha\s+los\s+env[ií]os|transforma\s+tu\s+(espacio|hogar)|haz\s+tu\s+pedido|contacta(?:r|nos)?\s+ahora|¡?descubre\s+nuestro/i;

  api.textOf = function (el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  };

  api.isZeroish = function (v) {
    var n = parseFloat(String(v == null ? '' : v).replace(',', '.').replace(/[^\d.-]/g, ''));
    return !isFinite(n) || n === 0;
  };

  api.isMeaningfulP = function (p) {
    var t = api.textOf(p);
    if (!t || t.length < 40) return false;
    if (/^(especificaciones|dimensiones|caracter[ií]sticas|beneficios)\s*:?$/i.test(t)) return false;
    if (api.JUNK_RE.test(t) && t.length < 220) return false;
    if (/elige el color del casco|acabado de tu swim/i.test(t)) return false;
    return true;
  };
})(window.IlmasPdp);
